// import React, { useContext, useState } from 'react';
import React, { useContext, useState, useEffect } from 'react';
import Layout from '../../components/Layout';

import CartProducts from './CartProducts';
import { CartContext } from '../../contexts/CartContext';
import { formatNumber } from '../../helpers/utils';
import { Link } from 'react-router-dom';

import { Alert, Form } from 'react-bootstrap'

// Helpers moved outside component to avoid hook dependency warnings
function _getOvernightShippingPrice(_itemCount) {
    if (_itemCount <= 2) { return 25.00; }
    else if (_itemCount <= 4) { return 50.00; }
    else { return _itemCount * 10.5; }
}

function _getShippingOptions(itemCount, isPromoApplied) {
    let options = [null];

    const standardShippingPrice = itemCount === 1 ? 4.47 : 0;
    options.push(`Standard Shipping (5 - 7 Business Days) - $${standardShippingPrice.toFixed(2)}`)

    options.push(`Overnight Shipping - $${_getOvernightShippingPrice(itemCount).toFixed(2)}`)

    return options;
}

const Cart = () => {

    const { total, cartItems, itemCount, clearCart, checkout } = useContext(CartContext);


    const [isPromoApplied, setIsPromoApplied] = useState(false);
    const [promoInput, setPromoInput] = useState("")
    const [shippingOption, setShippingOption] = useState(null);

    // Ensure default shipping is selected and updated when cart quantity changes
    useEffect(() => {
        const options = _getShippingOptions(itemCount, isPromoApplied);

        // Desired default based on quantity
        const desiredDefault = `Standard Shipping (5 - 7 Business Days) - $${(itemCount === 1 ? 4.47 : 0).toFixed(2)}`;

        // If no selection yet, or current selection is standard shipping, sync to desired default
        if (
            shippingOption == null ||
            (typeof shippingOption === 'string' && shippingOption.includes('Standard Shipping (5 - 7 Business Days)'))
        ) {
            // Only set if the desired option exists in the current options list
            if (options.includes(desiredDefault)) {
                setShippingOption(desiredDefault);
            }
        } else if (typeof shippingOption === 'string' && shippingOption.includes('Overnight Shipping')) {
            const correctOvernightOption = `Overnight Shipping - $${_getOvernightShippingPrice(itemCount).toFixed(2)}`;
            if (options.includes(correctOvernightOption)) {
                setShippingOption(correctOvernightOption);
            }
        }
    }, [itemCount, isPromoApplied, shippingOption]);

    const renderCartStatus = (total, itemCount) => {
        let message = null;

        if (itemCount === 1) {
            message = "Standard shipping is $4.47 for one datebook."
        }
        else if (itemCount > 1) {
            message = "Standard shipping is free for two or more datebooks."
        }
        return message != null ?
            <Alert variant="info">{message}</Alert>
            :
            null
    }

    function _getPriceFromShippingString(shippingString) {
        if (!shippingString) return;
        return Number(shippingString.split('$')[1]);
    }

    function _getShippingDescription(shippingString) {
        if (!shippingString) return;
        return shippingString.split(' - $')[0];
    }

    // console.log('shipping', _getPriceFromShippingString(shippingOption), _getShippingDescription(shippingOption))

    // TODO: there's a bug where the shipping option is stale if the user increments or decrements a cart item.

    const _handleShipping = (event) => {
        console.log(event.target.value);
        setShippingOption(event.target.value);
    }

    const onPromoButtonClick = (event) => {
        event.preventDefault();
        setIsPromoApplied(promoInput.trim().toUpperCase() === 'BOGO2027');
    }

    const getSavings = (_itemCount, _isPromoApplied) => {
        let savings = 0;

        if (_itemCount >= 5) {
            savings += 5 * _itemCount;
        }

        if (_isPromoApplied && _itemCount >= 2) {
            savings += (_itemCount >= 5 ? 14.95 : 19.95);
        }
        return savings;
    }

    const getGrandTotal = (subtotal, _itemCount, _isPromoApplied) => {
        let grandTotal = Number(subtotal) || 0;

        if (_itemCount >= 5) {
            grandTotal -= _itemCount * 5;
        }
        if (_isPromoApplied && _itemCount >= 2) {
            grandTotal -= (_itemCount >= 5 ? 14.95 : 19.95)
        }

        grandTotal += _getPriceFromShippingString(shippingOption) || 0;

        return grandTotal;
    }

    async function handleCheckoutClick() {
        try {
            let cartstr = '';
            const elements = document.querySelectorAll('.lineitem');
            elements.forEach((elem) => {
                const itemId = elem.getAttribute('data-itemid');
                const quantity = elem.getAttribute('data-quantity');
                const price = elem.getAttribute('data-price');
                const name = elem.getAttribute('data-name');
                cartstr += `${itemId}^${quantity}^${price}^${name}|`;
            });

            // Use mode: 'no-cors' to avoid CORS error in development and successfully persist cookies
            await fetch(`https://www.datebook.com/checkout_listener.aspx?mode=create&cart=${encodeURIComponent(cartstr)}`, { mode: 'no-cors' });
            window.location.href = 'https://www.datebook.com/webcart.aspx?mode=Cart';
        } catch (error) {
            alert('Please call us for technical support');
        }
    }

    return (
        <Layout title="Cart" description="This is the Cart page" >
            <div >
                <div className="text-center mt-5">
                    <h1 className="mb-3 text-danger">Cart</h1>
                </div>

                {renderCartStatus(total, itemCount)}

                <div className="row no-gutters justify-content-center">
                    <div className="col-md-8 p-3">
                        {
                            cartItems.length > 0 ?
                                <>
                                    <CartProducts />

                                    {
                                        // 5 ITEMS PROMO
                                        itemCount >= 5 ?
                                            <div id="promo-5-items" className="row no-gutters py-2">
                                                <div className="col-sm-2 p-2 d-none d-sm-block">
                                                </div>
                                                <div className="col-6 col-sm-4 p-2">
                                                    <h5 className="mb-1">{"PROMO: $14.95 each with 5 or more"}</h5>
                                                    <p className="mb-1">Price: {formatNumber(-5)} </p>
                                                </div>
                                                <div className="col-4 col-sm-2 p-2 text-center ">
                                                    <p className="mb-0">Qty: {itemCount}</p>
                                                </div>
                                                <div className="col-2 col-sm-4 p-2 text-right">
                                                </div>
                                            </div>
                                            :
                                            null
                                    }

                                    {/* TODO: Adjustments - promo and shipping */}
                                    <span className="lineitem" style={{ display: "none" }} data-itemid="shipping" data-quantity={1} data-price={_getPriceFromShippingString(shippingOption)} data-name={_getShippingDescription(shippingOption)}></span>


                                    {isPromoApplied && itemCount >= 2 ?
                                        <>
                                            <div id="promo-lineitem" className="row no-gutters py-2">
                                                <div className="col-sm-2 p-2 d-none d-sm-block">
                                                </div>
                                                <div className="col-6 col-sm-4 p-2">
                                                    <h5 className="mb-1">{"BOGO COUPON"}</h5>
                                                    <p className="mb-1">Price: {formatNumber(itemCount >= 5 ? -14.95 : -19.95)} </p>
                                                </div>
                                                <div className="col-4 col-sm-2 p-2 text-center ">
                                                    <p className="mb-0">Qty: {1}</p>
                                                </div>
                                                <div className="col-2 col-sm-4 p-2 text-right">
                                                </div>
                                            </div>

                                            <span className="lineitem" style={{ display: "none" }} data-itemid="coupon" data-quantity={1} data-price={itemCount >= 5 ? -14.95 : -19.95} data-name={"BOGO COUPON"}></span>
                                        </> : null}
                                </> :
                                <div className="p-3 text-center text-muted">
                                    Your cart is empty
                                </div>
                        }

                        {checkout &&
                            <div className="p-3 text-center text-success">
                                <p>Checkout successfull</p>
                                <Link to="/" className="btn btn-outline-success btn-sm">BUY MORE</Link>
                            </div>
                        }
                    </div>
                    {
                        cartItems.length > 0 &&
                        <div className="col-md-4 p-3">
                            <div className="card card-body">
                                <p className="mb-1">Total Items</p>
                                <h4 className=" mb-3 txt-right">{itemCount}</h4>
                                <div id="shipping-options">
                                    <Form>
                                        <Form.Group controlId="exampleForm.SelectCustom">
                                            <Form.Label>Shipping Options</Form.Label>
                                            <Form.Control as="select" custom onChange={_handleShipping} value={shippingOption || ''}>
                                                {_getShippingOptions(itemCount, isPromoApplied).map((opt, index) => <option key={index}>{opt}</option>)}
                                            </Form.Control>
                                        </Form.Group>
                                    </Form>
                                </div>

                                {/* <div id="promo-group">
                                    <label>Promo Code</label>
                                    <div id="promo-input" className="input-group mb-3">
                                        <input onChange={(evt) => { setPromoInput(evt.target.value) }} value={promoInput} type="text" className="form-control" placeholder="Promo code" aria-label="Promo code" aria-describedby="basic-addon2" />
                                        <button onClick={onPromoButtonClick} className="btn btn-sm btn-danger input-group-append" style={{ alignItems: 'center' }}>Apply Promo</button>
                                    </div>
                                    <div id="promo-message" style={{ fontSize: "0.8em", color: isPromoApplied && itemCount >= 2 ? 'green' : 'red' }}>
                                        {isPromoApplied ? (itemCount >= 2 ? "promo code applied!" : "BOGO2027 requires at least 2 items.") : null}
                                    </div>
                                </div> */}


                                <div id="subtotal">
                                    <p className="mb-1">Subtotal</p>
                                    <h3 className="m-0 txt-right">{formatNumber(total)}</h3>
                                </div>

                                {getSavings(itemCount, isPromoApplied) > 0 ?
                                    <div id="savings">
                                        <p className="mb-1">Savings</p>
                                        <h3 className="m-0 txt-right">{formatNumber(getSavings(itemCount, isPromoApplied))}</h3>
                                    </div>
                                    :
                                    null
                                }

                                <div id="grand-total">
                                    <p className="mb-1">Shipping</p>
                                    <h3 className="m-0 txt-right">{formatNumber(_getPriceFromShippingString(shippingOption) || 0)}</h3>
                                    <hr className="my-3" />
                                    <p className="mb-1">Grand Total</p>
                                    <h3 className="m-0 txt-right">{formatNumber(getGrandTotal(total, itemCount, isPromoApplied))}</h3>
                                </div>

                                <hr className="my-4" />
                                <div className="text-center">
                                    <button id="btn_checkout" disabled={shippingOption == null} type="button" className="btn btn-primary mb-2" onClick={handleCheckoutClick}>CHECKOUT</button>
                                    <button type="button" className="btn btn-secondary mb-2" onClick={clearCart}>CLEAR</button>
                                </div>

                            </div>
                        </div>
                    }

                </div>
                <span id="debugger"></span>
            </div>
        </Layout>
    );
}

export default Cart;